import { Permission } from "../../slices/user/Types";

export type UserListRefreshTarget = "hid" | "partner-global" | "partner-org";

export const userSagaActionTypes = {
  callGetUserListSaga: "callGetUserListSaga",
  callGetUserDetailSaga: "callGetUserDetailSaga",
  callAddUserSaga: "callAddUserSaga",
  callUpdateUserSaga: "callUpdateUserSaga",
  callDeleteUserSaga: "callDeleteUserSaga",
  callGetUserListHIDSaga: "callGetUserListHIDSaga",
  callGetUsersByTypeSaga: "callGetUsersByTypeSaga",
  callUpdateUserMyAccountSaga: "callUpdateUserMyAccountSaga",
  callGetUserRolePermissionsSaga: "callGetUserRolePermissionsSaga",
  callGetPartnerRolesSaga: "callGetPartnerRolesSaga",
  callGetHidRolesSaga: "callGetHidRolesSaga",
  callEditUserRolePermissionsSaga: "callEditUserRolePermissionsSaga",
  callToggleUserEnableSaga: "callToggleUserEnableSaga",
  callSendAccountInviteSaga: "callSendAccountInviteSaga",
  callDeleteRoleSaga: "callDeleteRoleSaga",
  callCreateRoleSaga: "callCreateRoleSaga",
  callUpdateRoleSaga: "callUpdateRoleSaga",
  callGetRolePermissionDetailSaga: "callGetRolePermissionDetailSaga",
  callUpsertRolePermissionsSaga: "callUpsertRolePermissionsSaga",
};

export const getUserListSagaAction: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: userSagaActionTypes.callGetUserListSaga,
    payload: {
      ID: ID,
    },
  };
};

export const getUserDetailSagaAction: (ID: number) => {
  type: string;
  payload: {
    ID: number;
  };
} = (ID: number) => {
  return {
    type: userSagaActionTypes.callGetUserDetailSaga,
    payload: {
      ID: ID,
    },
  };
};

export type addUserPayloadType = {
  first_name: string;
  last_name: string;
  email: string;
  phone_number?: string;
  status: string;
  role: string;
  role_id?: number;
  address1?: string;
  city?: string;
  province?: string;
  country?: string;
  zip?: string;
  partner?: number;
};

export const addUserSagaAction: (
  data: addUserPayloadType,
  options?: { listRefreshTarget?: UserListRefreshTarget }
) => {
  type: string;
  payload: addUserPayloadType & { listRefreshTarget?: UserListRefreshTarget };
} = (data, options) => {
  return {
    type: userSagaActionTypes.callAddUserSaga,
    payload: { ...data, listRefreshTarget: options?.listRefreshTarget },
  };
};

export type updateUserPayloadType = {
  ID: number;
  first_name: string;
  last_name: string;
  phone?: string;
  status: string;
  role?: string;
  role_id?: number;
  address1?: string;
  city?: string;
  province?: string;
  country?: string;
  zip?: string;
  partner?: number;
};

export const updateUserSagaAction: (
  user: updateUserPayloadType,
  options?: { listRefreshTarget?: UserListRefreshTarget }
) => {
  type: string;
  payload: {
    user: updateUserPayloadType;
    listRefreshTarget?: UserListRefreshTarget;
  };
} = (user, options) => {
  return {
    type: userSagaActionTypes.callUpdateUserSaga,
    payload: {
      user,
      listRefreshTarget: options?.listRefreshTarget,
    },
  };
};

export const deleteUserSagaAction: (data: {
  userID: number;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  listType: "partner" | "hid" | "partner-global";
}) => {
  type: string;
  payload: {
    data: {
      userID: number;
      setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
      listType: "partner" | "hid" | "partner-global";
    };
  };
} = (data) => {
  return {
    type: userSagaActionTypes.callDeleteUserSaga,
    payload: {
      data: data,
    },
  };
};

export const getUserListHIDSagaAction: () => {
  type: string;
} = () => {
  return {
    type: userSagaActionTypes.callGetUserListHIDSaga,
  };
};

export type UserListByType = "HID" | "partner";

export const getUsersByTypeSagaAction: (userType: UserListByType) => {
  type: string;
  payload: { userType: UserListByType };
} = (userType) => {
  return {
    type: userSagaActionTypes.callGetUsersByTypeSaga,
    payload: { userType },
  };
};

export const updateUserMyAccountSagaAction: (user: updateUserPayloadType) => {
  type: string;
  payload: {
    user: updateUserPayloadType;
  };
} = (user: updateUserPayloadType) => {
  return {
    type: userSagaActionTypes.callUpdateUserMyAccountSaga,
    payload: {
      user: user,
    },
  };
};

export const getUserRolePermissionsSagaAction: () => {
  type: string;
} = () => {
  return {
    type: userSagaActionTypes.callGetUserRolePermissionsSaga,
  };
};

export const getPartnerRolesSagaAction: () => {
  type: string;
} = () => {
  return {
    type: userSagaActionTypes.callGetPartnerRolesSaga,
  };
};

export const getHidRolesSagaAction: () => {
  type: string;
} = () => {
  return {
    type: userSagaActionTypes.callGetHidRolesSaga,
  };
};

export type editUserRolePermissionsPayloadType = {
  role: string;
  permissions: Permission[];
};
export const editUserRolePermissionsSagaAction: (
  payload: editUserRolePermissionsPayloadType
) => {
  type: string;
  payload: editUserRolePermissionsPayloadType;
} = (payload) => {
  return {
    type: userSagaActionTypes.callEditUserRolePermissionsSaga,
    payload: payload,
  };
};

export const toggleUserEnableSagaAction: (payload: {
  ID: number;
  userEmail: string;
  enable: number;
}) => {
  type: string;
  payload: {
    ID: number;
    userEmail: string;
    enable: number;
  };
} = (payload) => {
  return {
    type: userSagaActionTypes.callToggleUserEnableSaga,
    payload: payload,
  };
};

export const sendAccountInviteSagaAction: (payload: {
  ID: number;
  userEmail: string;
}) => {
  type: string;
  payload: {
    ID: number;
    userEmail: string;
  };
} = (payload) => {
  return {
    type: userSagaActionTypes.callSendAccountInviteSaga,
    payload: payload,
  };
};

export const deleteRoleSagaAction: (payload: {
  ID: number;
  onSuccess?: (message: string) => void;
  onError?: (message: string) => void;
}) => {
  type: string;
  payload: {
    ID: number;
    onSuccess?: (message: string) => void;
    onError?: (message: string) => void;
  };
} = (payload) => {
  return {
    type: userSagaActionTypes.callDeleteRoleSaga,
    payload,
  };
};

export type createRolePayloadType = {
  name: string;
  type: string;
  description: string;
  clone_from_role_id?: number;
  onSuccess?: (message: string) => void;
  onError?: (message: string) => void;
};
export const createRoleSagaAction: (payload: createRolePayloadType) => {
  type: string;
  payload: createRolePayloadType;
} = (payload) => {
  return {
    type: userSagaActionTypes.callCreateRoleSaga,
    payload,
  };
};

export type updateRolePayloadType = {
  ID: number;
  name: string;
  type: string;
  description: string;
  status: 0 | 1;
  clone_from_role_id?: number;
  onSuccess?: (message: string) => void;
  onError?: (message: string) => void;
};
export const updateRoleSagaAction: (payload: updateRolePayloadType) => {
  type: string;
  payload: updateRolePayloadType;
} = (payload) => {
  return {
    type: userSagaActionTypes.callUpdateRoleSaga,
    payload,
  };
};

export const getRolePermissionDetailSagaAction: (payload: { roleID: number }) => {
  type: string;
  payload: { roleID: number };
} = (payload) => {
  return {
    type: userSagaActionTypes.callGetRolePermissionDetailSaga,
    payload,
  };
};

export const upsertRolePermissionsSagaAction: (payload: {
  role_id: number;
  permissions: Array<{ permission_id: number; action: string }>;
  onSuccess?: (message: string) => void;
  onError?: (message: string) => void;
}) => {
  type: string;
  payload: {
    role_id: number;
    permissions: Array<{ permission_id: number; action: string }>;
    onSuccess?: (message: string) => void;
    onError?: (message: string) => void;
  };
} = (payload) => {
  return {
    type: userSagaActionTypes.callUpsertRolePermissionsSaga,
    payload,
  };
};
